module.exports = __webpack_public_path__ + "static/media/rapid-view-illustration.bcf0bc1e.svg";